<div class="dropdown buttonDownload" *ngIf="showDownloadButton">
  <button class="dropbtn" (click)="exportAll()">Download data</button>
</div>
<div #elRef class="bar" [style.--customHeight]="customHeight || '33rem'"></div>
